import React from 'react'
import ReactSlider from 'react-slider'
import './styles.scss'

interface Props {
  min: number
  max: number
  // defaultValue: number
  value: number
  onChange: (value:number)=>void
  onAfterChange: (value:number)=>void
}

export const Slider = ({ min, max, value, onChange, onAfterChange }: Props) => {

  return (
    <ReactSlider
      onChange={value => {
        onChange(value)
      }}
      onAfterChange={value => {
        onAfterChange(value)
      }}
      className='horizontal-slider'
      thumbClassName='slider-thumb'
      trackClassName='slider-track'
      max={max}
      min={min}
      value={value}
      renderThumb={(props, state) => <div {...props}><div /><div /><div /></div>}
    />
  )
}